module.exports = __webpack_public_path__ + "media/slow.5e702001.mp4";